import React, { useCallback, useEffect } from "react";
import { Form, Input, Row, Col } from "antd";
import { showJiraWidget } from "@/utils/utils";
import { createColor, updateColor } from "@/services/nissanColors";

export default function NissanColorForm({
  formRef,
  initialValues,
  editMode = false,
  setLoading,
  refreshTable,
  setVisible,
}) {
  useEffect(() => {
    formRef?.resetFields();
    formRef?.setFieldsValue(initialValues);
  }, [initialValues, formRef]);

  const onSubmit = useCallback(
    values => {
      setLoading(true);

      const apiCaller = editMode ? updateColor : createColor;

      apiCaller(values)
        .then(() => {
          formRef?.resetFields();
          setVisible(false);
          if (typeof refreshTable === "function") {
            refreshTable();
          }

          showJiraWidget();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [refreshTable, editMode, setVisible, setLoading],
  );

  return (
    <Form form={formRef} layout="vertical" initialValues={initialValues} onFinish={onSubmit}>
      <Row>
        <Col lg={24}>
          <Form.Item name="year" label="Year" rules={[{ required: true, message: "Please input year" }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col lg={24}>
          <Form.Item name="code" label="Code" rules={[{ required: true, message: "Please input code" }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col lg={24}>
          <Form.Item
            name="description"
            label="Description"
            rules={[{ required: true, message: "Please input description" }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>
    </Form>
  );
}
